export default __webpack_public_path__ + "static/media/Gift Annual Subscription.9e6e4b02.webp";